export default "__VITE_ASSET__CqVK6FIo__"